import { render, staticRenderFns } from "./CustomersBulletins.vue?vue&type=template&id=656f7613"
import script from "./CustomersBulletins.vue?vue&type=script&lang=js"
export * from "./CustomersBulletins.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports